import { CHART_COLORS } from "./config";
export function getCategoryColor(categoryIndex) {
    return CHART_COLORS[categoryIndex % CHART_COLORS.length];
}
// Utility function to truncate labels
export function truncateLabel(label, maxLength = 25) {
    // Handle null, undefined, or empty strings
    if (!label || typeof label !== "string") {
        return "(Sin nombre)";
    }
    if (label.length <= maxLength) {
        return label;
    }
    return label.substring(0, maxLength - 3) + "...";
}
